import { useStepSubmit } from '../../context/StepSubmitContext'
import { useOnboardingStore, STEPS } from '../../stores/onboardingStore'

// 1-based position of the Providers step — derived so it tracks STEPS reorders.
const PROVIDERS_STEP = STEPS.findIndex((s) => s.id === 'providers') + 1

export default function StepNavigation() {
  const current = useOnboardingStore((s) => s.currentStep)
  const stepsLength = useOnboardingStore((s) => s.steps.length)
  const liteMode = useOnboardingStore((s) => s.liteMode)
  const providersList = useOnboardingStore(
    (s) => s.formData?.providers?.providers,
  )
  const prevStep = useOnboardingStore((s) => s.prevStep)
  const { runHandler } = useStepSubmit()

  const total = liteMode ? 10 : stepsLength
  const isLast = current === total
  const isFirst = current === 1
  // In lite mode, show "Skip" on the Providers step when no providers have been
  // added yet — Step7Providers pushes a cleaned (non-empty-row) list to the
  // store on every keystroke, so this stays in sync.
  const showSkip =
    liteMode &&
    current === PROVIDERS_STEP &&
    (!Array.isArray(providersList) || providersList.length === 0)

  const onContinue = (e) => {
    e?.stopPropagation?.()
    document.activeElement?.blur?.()
    try {
      runHandler()
    } catch (err) {
      console.error('[StepNav] handler threw:', err)
    }
  }

  const onBack = (e) => {
    e?.stopPropagation?.()
    prevStep()
  }

  return (
    <div className="step-nav" data-no-tap="true">
      {!isFirst && (
        <button type="button" className="step-back" onClick={onBack}>
          <span aria-hidden="true">←</span> Back
        </button>
      )}
      <button type="button" className="step-continue cta" onClick={onContinue}>
        {isLast ? (
          'Complete'
        ) : showSkip ? (
          <>
            Skip <span aria-hidden="true">→</span>
          </>
        ) : (
          <>
            Continue <span aria-hidden="true">→</span>
          </>
        )}
      </button>
    </div>
  )
}
